
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class FillFollowDrawer extends Vue {
  visible = false;

  data: any = [];

  title = '';

  shopData: any = {};

  columns: any = [
    {
      title: '沟通时间',
      dataIndex: 'communication_time',
      key: 'communication_time',
      align: 'center',
    },
    {
      title: '沟通人',
      dataIndex: 'communicator',
      key: 'communicator',
      align: 'center',
    },
    {
      title: '沟通类型',
      dataIndex: 'communication_type',
      key: 'communication_type',
      align: 'center',
    },
    {
      title: '沟通结果',
      dataIndex: 'communication_result',
      key: 'communication_result',
      align: 'center',
    },
    {
      title: '预计签约时间',
      dataIndex: 'expected_signing_time',
      key: 'expected_signing_time',
      align: 'center',
    },
    {
      title: '原因',
      dataIndex: 'reason',
      key: 'reason',
      align: 'center',
    },
    {
      title: '二次动作',
      dataIndex: 'secondary_action',
      key: 'secondary_action',
      align: 'center',
    },
    {
      title: '签约结果',
      dataIndex: 'signing_result',
      key: 'signing_result',
      align: 'center',
    },
    {
      title: '沟通记录',
      dataIndex: 'communication_record',
      key: 'communication_record',
      align: 'center',
    },
  ];

  init(value: any) {
    this.visible = true;
    this.shopData = value;
    this.title = `跟进记录列表-${this.shopData.shop_name}`;
  }

  handleCancel() {
    this.visible = false;
  }
}
